const navigationSettings = {
  showExpandedCart: true,
  logo: "https://billedarkiv.blob.core.windows.net/images/6595fc8a-46f0-473d-9642-15e960fd0967",
};

export default navigationSettings;
